import React, { Component as C } from "react"
import PropTypes from "prop-types"

import BaseRow from "@cirrus/legacy/app-components/table-v2/table-rows/base-row/index.jsx"
import TableColumn from "@cirrus/legacy/app-components/table-v2/table-column/index.jsx"
import Radiobutton from "@cirrus/legacy/app-components/form-controls/radiobuttons/radiobutton/index.jsx"

import CommonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

class CheckboxRow extends C {
  static displayName = "TableRow"

  static propTypes = {
    id: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
  }

  render() {
    return (
      <BaseRow
        {...this.props}
        onClick={this.props.onSelect.bind(this, this.props.id)}
        className={CommonStyles.radiobuttonRow}>
        <TableColumn htmlType={this.props.htmlType} className={CommonStyles.radiobuttonColumn}>
          <Radiobutton
            id={this.props.id}
            className={CommonStyles.radiobutton}
            isChecked={this.props.isSelected}
          />
        </TableColumn>
        {this.props.children}
      </BaseRow>
    )
  }
}

export default CheckboxRow
